import { Stack, Typography } from '@mui/material';
import React from 'react';

import { colors } from '../theme/theme';

interface DashboardHeaderProps {
    icon?: string;
    mainTitle: React.ReactNode;
    subTitle?: React.ReactNode;
    iconColor?: string;
    iconBgColor?: string;
    iconSize?: number;
    iconPadding?: number;
    mainTitleFS?: number;
    subTitleFS?: number;
    cardGap?: number;
    iconBorderRadius?: number;
    mainTitleNoWrap?: boolean;
    cursorPointer?: string;
    onclick?: () => void;
    borderColor?: string;
    tabIndex?: number;
}

const CommonHeader: React.FC<DashboardHeaderProps> = ({
    icon,
    mainTitle,
    subTitle,
    iconColor,
    iconBgColor,
    iconSize = 24,
    iconPadding,
    mainTitleFS = 24,
    subTitleFS = 16,
    cardGap = 2,
    iconBorderRadius = 3,
    mainTitleNoWrap = false,
    cursorPointer,
    onclick,
    borderColor,
    tabIndex,
}) => {
    return (
        <Stack gap={cardGap} direction="row" alignItems="center">
            {icon && (
                <Stack
                    onClick={onclick}
                    sx={{
                        borderRadius: iconBorderRadius || '12px',
                        bgcolor: iconBgColor || colors.primaryLight[70],
                        p: iconPadding !== undefined ? iconPadding : { xs: 1.8, md: 2.25 },
                        width: 'fit-content',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: 'fit-content',
                        cursor: cursorPointer,
                        border: borderColor ? `1px solid ${borderColor}` : 'none',
                    }}
                    tabIndex={tabIndex}
                    onKeyDown={event => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            onclick && onclick();
                        }
                    }}
                >
                    <span
                        className={icon}
                        style={{
                            fontSize: iconSize,
                            color: iconColor || colors.fullWhite,
                        }}
                    />
                </Stack>
            )}

            <Stack gap={1}>
                <Typography
                    variant="h4"
                    fontWeight={600}
                    color="textPrimary"
                    fontSize={mainTitleFS}
                    noWrap={mainTitleNoWrap}
                    className="mainTitle"
                >
                    {mainTitle}
                </Typography>
                <Typography variant="body1" color="textSecondary" fontSize={subTitleFS}>
                    {subTitle}
                </Typography>
            </Stack>
        </Stack>
    );
};

export default CommonHeader;
